import { styled } from '@material-ui/core';

export const LabelContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  verticalAlign: 'top',
});

export const SubLabelContainer = styled('div')(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.common.lightText,
}));

export const SubLabel = styled('p')({
  padding: 0,
  margin: 0,
});

export const Label = styled('p')({
  fontSize: '14px',
  padding: 0,
  margin: 0,
});
